module.exports = __webpack_public_path__ + "static/media/bank_mandate_icon.e0a763bb.svg";